<div
  *ngIf="mobileDarkSiteLogo"
  [ngClass]="{
    'd-none': !isLightHeaderFooterEnable,
    'ddcfb-lg-fix': displayBusinessTypeSection
  }"
  class="logo-container navbar-brand d-lg-block"
>
  <a
    (click)="getLogoUrl(logo)"
    *ngIf="!corpPartner.displayBusinessLogo && !isBusiness"
    [attr.href]="logo?.mainLogoUrl"
    [attr.target]="logo?.mainLogoNewTab === 'true' ? '_blank' : '_self'"
    class="float-left"
  >
    <div class="logoTrim">
      <img
        (click)="homeClicked($event)"
        [attr.alt]="logo?.mainLogoAltText"
        [attr.src]="
          logo && logo.mainLogo
            ? logo.mainLogo
            : 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
        "
        class="siteLogo"
        id="main-logo"
      />
    </div>
  </a>
  <a
    (click)="getLogoUrl(logo)"
    *ngIf="corpPartner.displayBusinessLogo || isBusiness"
    [attr.href]="logo?.busiLogoUrl"
    [attr.target]="logo?.busiLogoNewTab === 'true' ? '_blank' : '_self'"
    class="float-left"
  >
    <div class="logoTrim">
      <img
        (click)="homeClicked($event)"
        [attr.alt]="logo?.busiLogoAltText"
        [attr.src]="
          logo && logo.busiLogo
            ? logo.busiLogo
            : 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
        "
        class="siteLogo"
        id="business-logo"
      />
    </div>
  </a>
  <a
    #triggerElement
    (click)="open(logo?.subLogoUrl, logo?.subLogoExtLinkPopup)"
    *ngIf="logo?.subLogo"
    aria-haspopup="true"
    class="mr-0 float-left"
    href="javascript:void(0);"
  >
    <img
      *ngIf="!corpPartner.displayBusinessLogo && !isBusiness"
      [attr.alt]="logo?.subLogoAltText"
      [attr.src]="
        logo && logo.subLogo
          ? logo.subLogo
          : 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
      "
      [ngClass]="{
        'logo-padding': corpPartner.displayBusinessLogo || isBusiness
      }"
      class="skyteam"
      id="skyteam-logo-1"
    />
  </a>
</div>
<div
  *ngIf="!mobileDarkSiteLogo"
  class="logo-container navbar-brand darkSiteLogoAlign"
>
  <a
    [attr.target]="logo?.mainLogoNewTab === 'true' ? '_blank' : '_self'"
    class="float-left"
    href="javascript:void(0);"
  >
    <div class="logoTrim">
      <img
        (click)="homeClicked($event)"
        [attr.alt]="logo?.mainLogoAltText"
        [attr.src]="
          logo && logo.mainLogo
            ? logo.mainLogo
            : 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
        "
        class="siteLogo"
        id="darksite-logo"
      />
    </div>
  </a>
  <a
    #triggerElement
    (click)="open(logo?.subLogoUrl, logo?.subLogoExtLinkPopup)"
    aria-haspopup="true"
    class="mr-0 float-left"
    href="javascript:void(0);"
  >
    <img
      *ngIf="!corpPartner.displayBusinessLogo && !isBusiness"
      [attr.alt]="logo?.subLogoAltText"
      [attr.src]="
        logo && logo.subLogo
          ? logo.subLogo
          : 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
      "
      class="skyteam"
      id="skyteam-logo-2"
    />
  </a>
</div>
